export const ROUTES = {
    GLOBAL: {
        LOGIN: "global/v1/login",
        GET_TYPES: "global/list/ilist/locationdentificationType",
        GET_CITIES: "global/list/location",
        PAYU_CONFIRMATION: "global/pay/payUConfirmation",
        UPLOAD_FILE: "global/upload",
        ENTITY: {
            GET_LIST_BY_KIND: "global/unity/findByKind",
            SAVE_ENTITY: "global/entity/save",
        },
        DOWNLOAD_FILE: "global/downloads/",
    },
    DASHBOARD: {
        PAY_METHODS: {
            SAVE_CONFIGURATION: "dashboard/pay/methods/save/configuration",
            GET_METHOD_PROPS: "dashboard/pay/methods/get-props",
        },
        GET_MENU: "dashboard/safe/account/v1/menu",
        GET_COMPANIES: "dashboard/core/company/list/fathers",
        SAVE_COMPANY: "dashboard/core/company/create",
        DELETE_COMPANY: "dashboard/core/company/remove",
        GET_SAVED_COMPANIES: "dashboard/core/company/find",
        GET_COMPANIES_TREE: "dashboard/core/company/list/tree",
        GET_EXTRA_INFO: "dashboard/core/company/info/classification",
        GET_VEHICLE_TYPES: "dashboard/core/vehicle/list/type",
        REPORTS: {
            EASY_POINT: {
                DOWNLOAD_REPORT: "/reports/easypunto/download_report",
            },
            OCCUPATION: {
                DOWNLOAD_REPORT: "/reports/other_report/occupation",
                DATA_TABLE: "/reports/other_report/data_table",
            },

            DAILY: {
                DOWNLOAD_REPORT: "/reports/daily/document",
                DATA_TABLE: "/reports/daily/data_table",
            },
        },
        MP: {
            CREATE: "dashboard/mercadopago/order/create",
            QUERY: "dashboard/mercadopago/payment/${orden}",
            CANCEL: "dashboard/mercadopago/order/delete",
        },
        DEVICES: {
            GENERATE_TOKEN: "dashboard/machine/devices/generate-token",
        },
        SYNC: {
            CHECK: "dashboard/data/check-sync-configuration",
        },
        ACCESS: {
            GET_ACCOUNTS: "dashboard/safe/account/get-accounts",
            SAVE_ACCOUNT: "dashboard/core/access/save",
            GET_BY_CODE: "dashboard/core/access/find-by-id",
            GET_PERMISSION: "dashboard/core/access/find-permission",
            CHECK_TOKEN: "dashboard/safe/account/checktoken",
        },
        COMPANY: {
            GET_BY_CODE: "dashboard/core/company/findById",
            FIND_BY_CARD_ID: "dashboard/core/company/findByCardId",
        },
        SUBSCRIPTIONS: {
            GET_BY_CODE: "dashboard/pay/subscriptions/find-by-code",
        },
        USERS: {
            GET_USER_BY_IDENTIFICATION:
                "dashboard/core/entity/find-by-identification",
            SEARCH: "dashboard/core/entity/search",
            GET_USER_LIST: "dashboard/core/entity/list",
            GET_USER_BY_CODE: "dashboard/core/entity/findByCode",
            GET_ACCESS_LIST: "dashboard/core/access/list",
        },
        CALENDAR: {
            SAVE_CALENDAR: "dashboard/core/calendar/create",
            GET_CALENDAR: "dashboard/core/calendar/findAll",
            DELETE_CALENDAR: "dashboard/core/calendar/deleteById",
        },
        LIQUIDATIONS: {
            GET_LIQUIDATIONS: "dashboard/billing/liquidation/list",
            FIND_BY_ID: "dashboard/billing/liquidation/find-by-code",
            DELETE: "dashboard/billing/liquidation/delete",
            SAVE: "dashboard/billing/liquidation/save",
            GET_FUNCTIONS: "dashboard/billing/liquidation/functions/list",
            GET_RELATEDS: "dashboard/billing/liquidation/get-related-list",
            GET_MODES: "dashboard/billing/liquidation/modes-list",
            GET_LIQUIDATIONS_COMPLETE: "dashboard/billing/liquidation/list-complete",
            DELETE_RELATED: "dashboard/billing/liquidation/delete-concept-liquidation",
            UPDATE_LIQUIDATION_CONCEPT: "dashboard/billing/liquidation/edit-value-related",
            FIND_LIQUIDATION_CONCEPT: "dashboard/billing/liquidation/get-liquidation-concept",
            COPY_LIQUIDATION: "dashboard/billing/liquidation/copy-liquidation",
        },
        RESOLUTION: {
            SAVE_RESOLUTION: "dashboard/billing/resolution/create",
            GET_RESOLUTION: "dashboard/billing/resolution/list",
            DELETE_RESOLUTION: "dashboard/billing/resolution/delete",
            GET_LIQUIDATIONS: "dashboard/billing/liquidation/list-by-company",
            GET_DEVICES: "dashboard/billing/resolution/get-devices",
            GET_FIND_BY_CODE: "dashboard/billing/resolution/find",
        },
        CONCEPTS: {
            LIST_BY_COMPANY: "dashboard/billing/concept/list",
            LIST_RELATEDS: "dashboard/billing/concept/get-relateds",
            SAVE: "dashboard/billing/concept/save",
            DELETE: "dashboard/billing/concept/delete",
            GET_TYPES: "dashboard/billing/concept/get-types",
            LIST_CONCEPT_RELATEDS: "dashboard/billing/concept/get-concept-relateds",
            DELETE_CONCEPT: "dashboard/billing/concept/delete-concept",
            DELETE_CONCEPT_RELATED: "dashboard/billing/concept/delete-concept-related",
        },
        SCHEDULES: {
            SAVE_SCHEDULE: "dashboard/income/schedule/create",
            GET_SCHEDULES: "dashboard/income/schedule/listByTitle",
            GET_MP_SCHEDULES: "dashboard/income/schedule/listMP",
            GET_SCHEDULE_CLASSIFICATION:
                "dashboard/income/schedule/listClassifications",
            DELETE_SCHEDULES: "dashboard/income/schedule/remove",
        },
        INCOME: {
            SAVE_INCOME: "dashboard/income/setting/save",
            GET_INCOME: "dashboard/income/setting/findByCompany",
            SAVE_INCOME_MONTHLY: "dashboard/income/special/save",
            GET_INCOME_MONTHLY: "dashboard/income/special/list",
            DELETE_INCOME_MONTHLY: "dashboard/income/special/delete",
        },
        INCOME_SPECIAL: {
            GET_MONTHLY_TYPES: "dashboard/income/special/list/type",
        },

        DISCOUNTS: {
            SAVE_DISCOUNT: "dashboard/pay/voucher/create",
            SAVE_MASK_DISCOUNT: "dashboard/pay/voucher/mask/save",
            GET_DISCOUNT: "dashboard/pay/voucher/list",
            DELETE_DISCOUNT: "dashboard/pay/voucher/remove",
            GET_SECTIONS: "dashboard/pay/voucher/get-sections",
            GET_MASKS_RANGES: "dashboard/pay/voucher/mask/get-by-company",
            GET_DISCOUNT_FOREVER: "dashboard/pay/voucher/list-forever",
            GET_DISCOUNT_TYPE_DEVICE: "dashboard/pay/voucher/list-by-type-device",
            GET_DISCOUNT_CUFE: "dashboard/pay/voucher/list-cufe-discount",
            SAVE_DISCOUNT_CUFE: "dashboard/pay/voucher/save-cufe-discount",
            DELETE_DISCOUNT_CUFE: "dashboard/pay/voucher/delete-cufe-discount",
        },
        RATES: {
            GET_RATE_BY_CODE: "dashboard/billing/tariff/get-by-code",
            GET_RATES: "dashboard/billing/tariff/list",
            SAVE_RATE: "dashboard/billing/tariff/create",
            DELETE_RATE: "dashboard/billing/tariff/delete",
            GET_RATES_COMPLETE: "dashboard/billing/tariff/list-complete",
            DELETE_SEGMENT_RATE: "dashboard/billing/tariff/delete-segment",
        },
        CONFIG_DEVICES: {
            GET_TECHNOLOGIES: "dashboard/machine/devices/tecnnologies",
            GET_DEVICE_TYPES: "dashboard/machine/devices/device_types",
            GET_LIST_DEVICCES: "dashboard/machine/devices/get_devices",
            GET_COMPANY_DEVICES_LIST: "dashboard/machine/devices/get_company_devices",
            SAVE_DEVICE: "dashboard/machine/devices/save",
            GET_MODULE_GROUPS: "dashboard/machine/devices/get_module_groups",
            GET_DEVICES_ACTIVED: "dashboard/machine/devices/get_device_activities",
            DELETE: "dashboard/machine/devices/delete",
            GET_DEVICE_TYPE_FIELDS:
                "dashboard/machine/devices/get_device_type_fields",
            GET_DEVICE: "dashboard/machine/devices/get_device",
        },
        ENTITY: {
            FIND_PERSON: "dashboard/data/entity/find",
            GET_LIST_BY_KIND: "dashboard/data/unity/findByKind",
            PAYMENT_METHODS: "dashboard/data/unity/methodsByCompany",
            ALL_PAYMENT_METHODS: "dashboard/data/unity/findByKind",
            SAVE_ENTITY: "dashboard/core/entity/save",
            SEARCH_USERS: "dashboard/core/entity/search-users",
            GET_LIST_BY_FATHER: "dashboard/data/unity/findByFather",
        },
        SLOTS: {
            SAVE: "dashboard/core/slot/create",
            GET_FATHERS: "dashboard/core/slot/fathers",
            GET_SLOTHS: "dashboard/core/slot/list",
            LIST_ALL_BY_COMPANY: "dashboard/core/slot/list-all-by-company",
            DELETE_SLOTH: "dashboard/core/slot/remove",
        },
        MERCADO_PAGO: {
            GET_EXTERNAL_ID: "dashboard/mercadopago/get_external_id",
            POS: {
                SAVE: "dashboard/mercadopago/pos/create",
                UPDATE: "dashboard/mercadopago/pos/update",
                LIST: "dashboard/mercadopago/pos/list",
                DELETE: "dashboard/mercadopago/pos/delete",
            },
            MP: {
                CREATE: "dashboard/mercadopago/order/create",
                QUERY: "dashboard/mercadopago/payment/${orden}",
                CANCEL: "dashboard/mercadopago/order/delete",
            },
            DEVICES: {
                GENERATE_TOKEN: "dashboard/machine/devices/generate-token",
            },
            SYNC: {
                CHECK: "dashboard/data/check-sync-configuration",
            },
            ACCESS: {
                GET_ACCOUNTS: "dashboard/safe/account/get-accounts",
                SAVE_ACCOUNT: "dashboard/safe/account/save",
            },
            COMPANY: {
                GET_BY_CODE: "dashboard/core/company/findById",
            },
            SUBSCRIPTIONS: {
                GET_BY_CODE: "dashboard/pay/subscriptions/find-by-code",
            },
            USERS: {
                GET_USER_BY_IDENTIFICATION:
                    "dashboard/core/entity/find-by-identification",
                SEARCH: "dashboard/core/entity/search",
            },
            CALENDAR: {
                SAVE_CALENDAR: "dashboard/core/calendar/create",
                GET_CALENDAR: "dashboard/core/calendar/findAll",
                DELETE_CALENDAR: "dashboard/core/calendar/deleteById",
            },
            LIQUIDATIONS: {
                GET_LIQUIDATIONS: "dashboard/billing/liquidation/list",
                FIND_BY_ID: "dashboard/billing/liquidation/find-by-code",
                DELETE: "dashboard/billing/liquidation/delete",
                SAVE: "dashboard/billing/liquidation/save",
                GET_FUNCTIONS: "dashboard/billing/liquidation/functions/list",
                GET_RELATEDS: "dashboard/billing/liquidation/get-related-list",
                GET_MODES: "dashboard/billing/liquidation/modes-list",
            },
            RESOLUTION: {
                SAVE_RESOLUTION: "dashboard/billing/resolution/create",
                GET_RESOLUTION: "dashboard/billing/resolution/list",
                DELETE_RESOLUTION: "dashboard/billing/resolution/delete",
                GET_LIQUIDATIONS: "dashboard/billing/liquidation/list-by-company",
            },
            CONCEPTS: {
                LIST_BY_COMPANY: "dashboard/billing/concept/list",
                LIST_RELATEDS: "dashboard/billing/concept/get-relateds",
                SAVE: "dashboard/billing/concept/save",
                DELETE: "dashboard/billing/concept/delete",
                GET_TYPES: "dashboard/billing/concept/get-types",
            },
            SCHEDULES: {
                SAVE_SCHEDULE: "dashboard/income/schedule/create",
                GET_SCHEDULES: "dashboard/income/schedule/listByTitle",
                GET_MP_SCHEDULES: "dashboard/income/schedule/listMP",
                GET_SCHEDULE_CLASSIFICATION:
                    "dashboard/income/schedule/listClassifications",
                DELETE_SCHEDULES: "dashboard/income/schedule/remove",
            },
            INCOME: {
                SAVE_INCOME: "dashboard/income/setting/save",
                GET_INCOME: "dashboard/income/setting/findByCompany",
                SAVE_INCOME_MONTHLY: "dashboard/income/special/save",
                GET_INCOME_MONTHLY: "dashboard/income/special/list",
                DELETE_INCOME_MONTHLY: "dashboard/income/special/delete",
            },
            DISCOUNTS: {
                SAVE_DISCOUNT: "dashboard/pay/voucher/create",
                SAVE_MASK_DISCOUNT: "dashboard/pay/voucher/mask/save",
                GET_DISCOUNT: "dashboard/pay/voucher/list",
                DELETE_DISCOUNT: "dashboard/pay/voucher/remove",
                GET_SECTIONS: "dashboard/pay/voucher/get-sections",
                GET_MASKS_RANGES: "dashboard/pay/voucher/mask/get-by-company",
            },
            RATES: {
                GET_RATE_BY_CODE: "dashboard/billing/tariff/get-by-code",
                GET_RATES: "dashboard/billing/tariff/list",
                SAVE_RATE: "dashboard/billing/tariff/create",
                DELETE_RATE: "dashboard/billing/tariff/delete",
                GET_RATES_COMPLETE: "dashboard/billing/tariff/list-complete",
            },
            CONFIG_DEVICES: {
                GET_TECHNOLOGIES: "dashboard/machine/devices/tecnnologies",
                GET_DEVICE_TYPES: "dashboard/machine/devices/device_types",
                GET_LIST_DEVICCES: "dashboard/machine/devices/get_devices",
                GET_COMPANY_DEVICES_LIST:
                    "dashboard/machine/devices/get_company_devices",
                SAVE_DEVICE: "dashboard/machine/devices/save",
                GET_MODULE_GROUPS: "dashboard/machine/devices/get_module_groups",
                GET_DEVICES_ACTIVED: "dashboard/machine/devices/get_device_activities",
                DELETE: "dashboard/machine/devices/delete",
                GET_DEVICE_TYPE_FIELDS:
                    "dashboard/machine/devices/get_device_type_fields",
                GET_DEVICE: "dashboard/machine/devices/get_device",
            },
            ENTITY: {
                FIND_PERSON: "dashboard/data/entity/find",
                GET_LIST_BY_KIND: "dashboard/data/unity/findByKind",
                PAYMENT_METHODS: "dashboard/data/unity/methodsByCompany",
                ALL_PAYMENT_METHODS: "dashboard/data/unity/findByKind",
                SAVE_ENTITY: "dashboard/core/entity/save",
                SEARCH_USERS: "dashboard/core/entity/search-users",
            },
            SLOTS: {
                SAVE: "dashboard/core/slot/create",
                GET_FATHERS: "dashboard/core/slot/fathers",
                GET_SLOTHS: "dashboard/core/slot/list",
                LIST_ALL_BY_COMPANY: "dashboard/core/slot/list-all-by-company",
                DELETE_SLOTH: "dashboard/core/slot/remove",
            },
            MERCADO_PAGO: {
                GET_EXTERNAL_ID: "dashboard/mercadopago/get_external_id",
                POS: {
                    SAVE: "dashboard/mercadopago/pos/create",
                    UPDATE: "dashboard/mercadopago/pos/update",
                    LIST: "dashboard/mercadopago/pos/list",
                    DELETE: "dashboard/mercadopago/pos/delete",
                },
                SAVE: "dashboard/mercadopago/store/create",
                UPDATE: "dashboard/mercadopago/store/update",
                LIST: "dashboard/mercadopago/store/list",
                DELETE: "dashboard/mercadopago/store/delete",
            },
            PAY: {
                METHODS: {
                    SAVE: "dashboard/pay/methods/save",
                    DELETE: "dashboard/pay/methods/delete",
                    LIST_BY_COMPANY: "dashboard/pay/methods/listByCompany",
                },
            },
        },
    },
};
